// extracted by mini-css-extract-plugin
export default {"contentWrapper":"pcuhM ZdH1P","withoutTabs":"g9fbR","tabsWrapper":"BiQRt ZdH1P","hidden":"XodsX","active":"cXcbl"};